import { render, staticRenderFns } from "./WidgetsPurchasePaymentBucket.vue?vue&type=template&id=2aebb9d0"
import script from "./WidgetsPurchasePaymentBucket.vue?vue&type=script&lang=js"
export * from "./WidgetsPurchasePaymentBucket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports